import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getTickers = () => {
  return axios.get('/portfolio/stocks/');
};

export const useTickers = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['tickers'],
    queryFn: () => getTickers(),
  });
};
